<header *ngIf="!isMobile">
    <nav class="navbar navbar-expand-sm navbar-light bg-white border-bottom box-shadow mb-3">
        <div class="container-fluid">
            <div class="svg-container">
                <img src="assets/icons/desktop/Scout_Desktop_Icon_BlueWhite.svg" />
            </div>
            <a class="navbar-brand" href="/">
                Scout
                <span class="badge fs-6 ms-2 me-2" *ngIf="environment === 'DEV' || environment === 'QA'" style="background-color: red; color: white;">{{environment}}</span>
            </a>
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target=".navbar-collapse" aria-controls="navbarItems" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="navbar-collapse collapse d-sm-inline-flex justify-content-between">
                <ul class="navbar-nav flex-grow-1">
                    <li class="nav-item" *ngIf="!settingsLoaded || !isScaleOperator">
                        <a class="nav-link" [routerLink]="['scheduling']" routerLinkActive="active-link">Scheduling</a>
                    </li>
                    <li class="nav-item" *ngIf="!settingsLoaded || !isScaleOperator">
                        <a class="nav-link" [routerLink]="['contracts']" routerLinkActive="active-link">Contracts</a>
                    </li>
                    <li class="nav-item" *ngIf="!settingsLoaded || !isScaleOperator">
                        <a class="nav-link" [routerLink]="['truckers']" routerLinkActive="active-link">Truckers</a>
                    </li>
                    <li class="nav-item" *ngIf="!settingsLoaded || !isScaleOperator">
                        <a class="nav-link" [routerLink]="['load-bank']" routerLinkActive="active-link">Load Bank</a>
                    </li>
                    <li class="nav-item" *ngIf="!settingsLoaded || !isScaleOperator">
                        <a class="nav-link" [routerLink]="['ticket-maintenance']" routerLinkActive="active-link">Ticket Maintenance</a>
                    </li>
                    <li class="nav-item" *ngIf="settingsLoaded && isCompuweighEnabled">
                        <a class="nav-link" [routerLink]="['scale-view']" routerLinkActive="active-link">Scale View</a>
                    </li>
                    <li class="nav-item" *ngIf="!settingsLoaded || !isScaleOperator">
                        <a class="nav-link" target="_blank" href="{{truckerRateReportUrl}}">Analytics</a>
                    </li>
                </ul>
                <div class="nav-controls me-2">
                    <button type="button" class="scout-ai-nav-btn" (click)="openScoutAi()" aria-label="Open Navigator-Scout assistant" title="Navigator-Scout">
                        <img src="assets/icons/desktop/ScoutAI_Desktop_Icon.svg" alt="" class="scout-ai-nav-icon" />
                    </button>
                    <span class="badge fs-6" *ngIf="environment === 'DEV' || environment === 'QA'" style="background-color: red; color: white;">{{environment}}</span>
                </div>
                <div class="navbar-text me-2 user-section" *ngIf="loginDisplay">
                    <span class="user-section-text">
                        <a href="#" class="link-primary" (click)="logout()">Log out</a> |
                        {{userName}}
                    </span>
                    <a href="#" *ngIf="!userPhotoUrl" class="link-primary" data-bs-toggle="modal" data-bs-target="#contactModal" title="User Settings"><i class="fa-solid fa-user-circle fa-xl"></i></a>
                    <div *ngIf="userPhotoUrl" class="svg-container user-photo-wrap">
                        <a href="#" class="link-primary" data-bs-toggle="modal" data-bs-target="#contactModal" title="User Settings">
                            <img [src]="userPhotoUrl" alt="User Photo" class="user-photo" />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </nav>
</header>


 
<header *ngIf="isMobile && (isMobileSearch == '/schedule-mobile' || isMobileSearch == '')">
    <nav class="navbar navbar-expand-sm navbar-light bg-white border-bottom box-shadow">
        <div class="container-fluid d-flex justify-content-center align-items-center">
            <div class="svg-container">
              <img src="assets/icons/mobile/Scout_Mobile_Icon_BlueWhite.svg" />
            </div>
          </div>        
    </nav>
</header>